import React from 'react';
import { FacebookF } from 'styled-icons/fa-brands/FacebookF';
import { LinkedinIn } from 'styled-icons/fa-brands/LinkedinIn';

import { composeFullUrl } from 'src/helpers';
import { useViewMode } from 'src/hooks';
import { BaseBox, BaseStyledLink } from 'src/kit';
import { LogoTiny } from 'src/components';
import StyledFooter from './Footer.styled';

const logoHref = composeFullUrl('/');

export const Footer = () => {
  const { isDesktopMode, isMobileMode } = useViewMode();

  return (
    <StyledFooter>
      {isDesktopMode && (
        <div className="ca-footer-content--desktop">
          <div className="ca-brand-cell">
            <a href={logoHref}>
              <LogoTiny color="white" />
            </a>
            <div className="ca-contact">
              | +44 (0) 20 3743 2612 |<a href="mailto:contact@sainoo.com">contact@sainoo.com</a>
            </div>
          </div>
          <div className="ca-social-cell">
            <div className="ca-social-list">
              <SocialIcons />
            </div>
          </div>
          <BaseBox className="ca-copyright" mt={{ xs: 10, md: 0 }} pl={{ xs: 30, md: 0 }}>
            <span>&copy; Sainoo {new Date().getFullYear()}</span>
          </BaseBox>
        </div>
      )}
      {isMobileMode && (
        <div className="ca-footer-content--mobile">
          <div className="ca-brand-row">
            <a href={logoHref}>
              <LogoTiny color="white" />
            </a>
            <div className="ca-contact">
              <div> +44 (0) 20 3743 2612 </div>
              <a href="mailto:contact@sainoo.com">contact@sainoo.com</a>
            </div>
            <div className="ca-spacer" />
            <div className="ca-social-cell">
              <div className="ca-social-list">
                <a
                  className="ca-social-list-item facebook"
                  href="https://www.facebook.com/sainoofficial"
                  target="_blank"
                >
                  <FacebookF size={14} />
                </a>
                <a
                  className="ca-social-list-item linkedin"
                  href="https://www.linkedin.com/company/sainoo"
                  target="_blank"
                >
                  <LinkedinIn size={14} />
                </a>
              </div>
            </div>
          </div>
          <BaseBox className="ca-copyright" mt={{ xs: 10, md: 0 }} pl={{ xs: 30, md: 0 }}>
            <span>&copy; Sainoo {new Date().getFullYear()}</span>
          </BaseBox>
        </div>
      )}
    </StyledFooter>
  );
};

const SocialIcons = () => (
  <>
    <BaseStyledLink
      className="ca-social-list-item facebook"
      href="https://www.facebook.com/sainoofficial"
      rel="noopener noreferrer"
      target="_blank"
    >
      <FacebookF size={14} />
    </BaseStyledLink>
    <BaseStyledLink
      className="ca-social-list-item linkedin"
      href="https://www.linkedin.com/company/sainoo"
      rel="noopener noreferrer"
      target="_blank"
    >
      <LinkedinIn size={14} />
    </BaseStyledLink>
  </>
);
